import { Modal } from '@ethsign/ui';
import classNames from 'classnames';
import { ReactNode } from 'react';

interface Props {
  title?: string;
  content?: string | ReactNode;
  onConfirm: () => void;
  children?: ReactNode;
  confirmText: string;
  icon: ReactNode;
  type: 'warn' | 'normal';
  open: boolean;
  loading?: boolean;
  onOpenChange: (open: boolean) => void;
  className?: string;
  variant?: any;
}
export const ConfirmModal = (props: Props) => {
  const {
    open,
    children,
    onConfirm,
    title,
    content,
    confirmText,
    icon,
    type = 'normal',
    onOpenChange,
    loading,
    className,
    variant
  } = props;
  return (
    <Modal
      trigger={children}
      open={open}
      onOpenChange={onOpenChange}
      confirmButtonProps={{ loading, variant }}
      onConfirm={onConfirm}
      confirmText={confirmText}
      className={className}
    >
      <div
        className={classNames('flex items-start flex-col justify-start', {
          'items-center': type === 'warn'
        })}
      >
        {icon}
        <div
          className={classNames('text-lg font-medium text-gray-900 mt-[20px]', {
            'text-center': type === 'warn'
          })}
        >
          {title}
        </div>
        <div
          className={classNames('text-sm text-gray-500 mt-[8px]  w-full', {
            'text-center': type === 'warn'
          })}
        >
          {content}
        </div>
      </div>
    </Modal>
  );
};
